import { TextField, IconButton, Badge, Grid } from '@material-ui/core';

import styled from 'styled-components';

import { getFontWeight, mediaQueries, getColorHeader, fontFamily } from '../../../../../../libs';
import ButtonComponent from '../../../../../Button';

export const Logo = styled.div`
  img {
    width: 190px;
    height: 70px;
    padding: 5px 10px;
    outline: none;
    border: none;

    @media (max-width: ${mediaQueries.smDefault}px) {
      width: 100px;
      height: auto;
    }
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: stretch;
  align-items: center;
  flex: 1;
  max-width: 220px;

  @media (max-width: ${mediaQueries.smDefault}px) {
    max-width: unset;
    padding-top: 5px;
    justify-content: ${({ renderComponents }) => (!renderComponents ? 'space-between' : 'left')} !important;
  }
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  flex: 1;

  @media (max-width: ${mediaQueries.smDefault}px) {
    min-width: 100%;
    padding: 5px 10px 8px 10px;
  }
`;

export const UserMenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  flex: 1;
  max-width: 350px;

  @media (max-width: ${mediaQueries.smDefault}px) {
    display: none;
  }
`;

export const UserMenuContainerMobile = styled.div`
  align-items: center;
  justify-content: space-between;

  @media (min-width: ${mediaQueries.smMin}px) {
    display: none;
  }
`;

export const Form = styled.form`
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const InputStyled = styled(TextField)`
  width: 100% !important;

  * {
    font-family: ${fontFamily} !important;
    border: unset !important;
  }

  & input {
    color: #555555 !important;
  }

  & label {
    color: #555555 !important;
    font-size: 16px;
  }

  .MuiInputBase-root {
    padding: 0 !important;
    border-radius: 25px;
    background: #fff !important;
    font-size: 17px;
    padding: 0px 5px !important;

    &:hover {
      box-shadow: 1px 1px 3px 1px #00000030;
      border-left-style: unset !important;
    }
  }

  .MuiInputLabel-outlined {
    transform: translate(14px, 17px) scale(1);
    max-width: 80% !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .MuiFormLabel-root.Mui-focused {
    color: #000 !important;
  }

  input {
    padding: 14px 10px;
    color: #777;
  }

  svg {
    font-size: 35px !important;
    color: ${getColorHeader} !important;
    cursor: pointer;
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    color: transparent !important;
  }

  @media (max-width: ${mediaQueries.smDefault}px) {
    width: 100% !important;

    & input {
      padding: 10px !important;
    }

    & .MuiInputLabel-outlined {
      transform: translate(14px, 13px) scale(1);
    }

    svg {
      font-size: 25px;
    }
  }
`;

export const ButtonIcon = styled(IconButton)`
  svg {
    font-size: 35px;
    color: #fff;
  }

  @media (max-width: ${mediaQueries.smDefault}px) {
    svg {
      font-size: 24px;
    }

    padding: 7px !important;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm.default + 1}px) {
    display: ${({ mobile }) => (mobile ? 'none' : 'unset')} !important;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 15px;
  max-width: 230px;

  @media (max-width: ${mediaQueries.smDefault}px) {
    display: none !important;
  }
`;

export const Text = styled.span`
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${({ bold }) => getFontWeight(bold)};
  font-size: ${({ fontsize }) => fontsize || '13px'};
  text-shadow: 0.5px 0.5px 3px #00000020;
`;

export const BadgeStyled = styled(Badge)`
  span {
    font-family: ${fontFamily} !important;
    font-weight: bold !important;
    font-size: 13px;
  }
  color: #fff;
`;

export const SignUp = styled.div`
  font-size: 13px;
  color: #fff;
  a {
    color: #fff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const LinkLogo = styled.a`
  display: flex;
  align-items: center;
`;

export const GridButton = styled(Grid)`
  padding: 12px 5px 0 5px !important;
`;

export const ListItem = styled.li`
  padding: 0px;
  display: flex;
  justify-content: center;

  svg {
    font-size: 40px;
    color: #bfbfbf;
    margin: 8px 5px;
  }
`;

export const Button = styled(ButtonComponent)`
  background: transparent !important;
  height: auto !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;

  &:hover {
    box-shadow: none !important;
    transition: none !important;
  }

  &:active {
    box-shadow: none !important;
    background: transparent !important;
  }
`;
